import React, { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";
import ReportView from "./ReportView";
import handleError from "../../../constants/handleError";
import AxiosInstance from "../../../utils/AxiosInstance";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import { usePermission } from "../../../context/PermissionContext";
import InvoiceTempPreview from "../settings/Invoice/InvoiceTempPreview";
import { formatCurrency } from "@heartinz/finance";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";

const ViewReportSalesReport = ({ isData, isLoading, isActive }) => {
  // console.log("isData", isData);
  const { isUser, updateSettings } = useAuth();
  const [reportModelOpen, setReportModelOpen] = useState(false);
  const [viewData, setViewData] = useState([]);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { storeSettings } = usePermission();
  const [isViewTempModalOpen, setViewTempModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectTermalOption, setSelectTermalOption] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedReturnOption, setSelectedReturnOption] = useState("RETURN");
  const templateId = storeSettings?.invoiceSettings?.template?.templateId;
  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/salereturn/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const handleSetTemplate = async (
    templateId,
    selectTermalOption,
    selectHalfA4Option,
    templateTheme,
    show = true,
  ) => {
    if (!checkNetwork()) return;
    try {
      const response = await AxiosInstance.patch(
        `module/storesettings/template`,
        {
          templateIdtemplateId: `${templateId}AND${selectTermalOption}AND${selectHalfA4Option}`,
          templateTheme,
        },
      );
      const results = response.data?.results?.invoiceSettings?.template;
      const id = results.templateId;
      const words = id.split("AND");
      setSelectedOption(words[0]);
      setSelectTermalOption(words[1]);
      setViewTempModalOpen(false);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            template: {
              templateId: results?.templateId,
              templateTheme: results?.templateTheme,
            },
            signature: results?.signature,
            termsAndConditions: results?.termsAndConditions,
          },
        },
      });
      {
        show && showAlert("success", "Template Selected...");
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSaleClose = () => {
    setViewModalOpen(false);
    setViewData(null);
    // navigate(location.pathname, { replace: true, state: {} });
  };

  const handleSaleView = async (item) => {
    // if (item.trackmode === "SALE") {
    const data = await handleSaleItems(item.saleReturnId);
    if (data) {
      setViewData(data);
      setViewModalOpen(true);
      setViewTempModalOpen(true);
    }
    // }
  };

  // const openSaleReportView = (item) => {
  //   setReportModelOpen(true);
  //   setViewData(item);
  // };
  const closeSaleReportView = () => {
    setReportModelOpen(false);
  };

  useEffect(() => {
    const id = storeSettings?.invoiceSettings?.template?.templateId || "";
    const words = id ? id?.split("AND") : [];
    setSelectedOption(words[0]);
    setSelectTermalOption(words[1]);
  }, []);

  return (
    <>
      <div className="table-responsive rtable">
        <table className="table table-sm table-bordered text-center">
          <tbody>
            <tr>
              <td className="fw-600">RETURN SALES REPORT</td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex rtable">
          <div className="w-50">
            <table className="table table-sm table-bordered">
              <tbody>
                <tr>
                  <td className="w-25">Name</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      isData?.reportInfo?.store?.title || ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">From Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.fromdate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.fromdate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">To Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.todate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.todate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">No of Return Sales</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `${isData?.reportSummary?.totalNoOfReturnSale || 0}`
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="w-10"></div>

          <div className="w-50 rtable">
            <table className="table table-sm table-bordered mb-0 text-center">
              <tbody>
                <tr>
                  <td className="w-25 fw-500">Base Total</td>
                  <td className="w-25 fw-500">GST Total</td>
                  <td className="w-25 fw-500">Grand Total</td>
                </tr>
                <tr>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.totalBasePrice) || 0,
                        "INR",
                      )}`
                    )}
                  </td>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.totalTaxAmount) || 0,
                        "INR",
                      )}`
                    )}
                  </td>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.totalReturnAmount) || 0,
                        "INR",
                      )}`
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <table className="table table-sm table-bordered mb-3 rtable">
          <tbody>
            <tr>
              <td className="text-center">S No</td>
              <td className="text-center">Retrun No</td>
              <td className="text-center">Date</td>
              <td className="text-center">Sale No</td>
              <td className="text-center">Sale Mode</td>
              <td className="text-center">Name</td>
              <td className="text-center">Phone</td>
              <td className="text-center">Tax Amount</td>
              <td className="text-center">Amount</td>
              {/* {isUser.stype === "MAIN" && (
                <td className="text-center">Generated By</td>
              )} */}
            </tr>
          </tbody>
          <tbody>
            {isLoading ? (
              [...Array(11)].map((_, index) => (
                <tr key={index}>
                  {[...Array(10)].map((__, i) => (
                    <td key={i} className="text-center">
                      <Skeleton variant="text" width={i === 0 ? 300 : 200} />
                    </td>
                  ))}
                </tr>
              ))
            ) : Array.isArray(isData?.reportData) &&
              isData?.reportData?.length > 0 ? (
              isData?.reportData?.map((item, index) => (
                <tr
                  key={item?._id || index}
                  className="position-relative  cursor-poInter hover-row"
                  onClick={() => handleSaleView(item)}
                >
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{item?.saleReturnNo}</td>
                  {/* <td className="text-center">
                    {
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          item?.saledate,
                          isUser?.timezone
                        )
                      ).date
                    } 
                  </td> */}
                  <td className="text-center">
                    <div className="d-flex flex-column">
                      <span className="text-nowrap text-heading fw-medium">
                        {
                          DateConverter.ISOToDisplayFormat(
                            DateConverter.convertToTimeZone(
                              item.saleReturnDate,
                              isUser.timezone,
                            ),
                          ).date
                        }
                      </span>
                      {/* <span className="text-nowrap">
                        <small>
                          {
                            DateConverter.ISOToDisplayFormat(
                              DateConverter.convertToTimeZone(
                                item.saledate,
                                isUser.timezone,
                              ),
                            ).time
                          }
                        </small>
                      </span> */}
                    </div>
                  </td>
                  <td className="text-center">{item?.saleNo}</td>
                  <td className="text-center">{item?.salemode}</td>
                  <td className="text-center">
                    {item?.CustomerInfo?.name
                      ? `${item?.CustomerInfo?.name}`
                      : "-"}
                  </td>
                  <td className="text-center">
                    {item?.CustomerInfo?.phone
                      ? `+91 ${item?.CustomerInfo?.phone}`
                      : " - "}
                  </td>

                  <td className="text-end">
                    {formatCurrency(
                      CurrencyConverter.toCurrency(
                        item?.totalTaxAmount || 0,
                        "INR",
                      ),
                      "INR",
                      false,
                      true,
                    )}
                  </td>

                  <td className="text-end">
                    {formatCurrency(
                      CurrencyConverter.toCurrency(
                        Number(item?.totalReturnAmount) || 0,
                        "INR",
                      ),
                      "INR",
                      false,
                      true,
                    )}
                  </td>
                  {/* {isUser.stype === "MAIN" && (
                    <td className="text-center">
                      {item.saleby?.storename || ""}
                    </td>
                  )} */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center p-2">
                  <small className="text-muted">
                    No sale found in the store. add some customers to get
                    started.
                  </small>
                </td>
              </tr>
            )}
          </tbody>
          <tbody>
            <tr>
              <td colSpan="7" className="text-center"></td>
              <td className="text-end fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `${formatCurrency(
                    CurrencyConverter.toCurrency(
                      isData?.reportSummary?.totalTaxAmount || 0,
                      "INR",
                    ),
                    "INR",
                    false,
                    true,
                  )}`
                )}
              </td>
              <td className="text-end fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `${formatCurrency(
                    CurrencyConverter.toCurrency(
                      isData?.reportSummary?.totalReturnAmount || 0,
                      "INR",
                    ),
                    "INR",
                    false,
                    true,
                  )}`
                )}
              </td>
            </tr>
          </tbody>
        </table>

        <table className="table table-sm table-bordered mb-0 rtable w-30 text-center">
          <thead>
            <tr>
              <td className="w-25">Tax %</td>
              {/* <td>Tax Amount</td> */}
              <td>SGST Amount</td>
              <td>CGST Amount</td>
              <td>IGST Amount</td>
            </tr>
          </thead>
          <tbody>
            {/* {isData?.reportData?.map((item, index) => (
              <tr key={index}>
                <td>{isLoading ? <Skeleton variant="text" /> : "0"}</td>
                <td>
                  {isLoading ? (
                    <Skeleton variant="text" />
                  ) : (
                    `₹${CurrencyConverter.toCurrency(
                      Number(item?.totalTaxAmount || 0),
                      "INR",
                    )}`
                  )}
                </td>
                <td>
                  {isLoading ? (
                    <Skeleton variant="text" />
                  ) : (
                    `₹${CurrencyConverter.toCurrency(
                      Number(item?.returnSgstamount || 0),
                      "INR",
                    )}`
                  )}
                </td>
                <td>
                  {isLoading ? (
                    <Skeleton variant="text" />
                  ) : (
                    `₹${CurrencyConverter.toCurrency(
                      Number(item?.returnCgstamount || 0),
                      "INR",
                    )}`
                  )}
                </td>
                <td>
                  {isLoading ? (
                    <Skeleton variant="text" />
                  ) : (
                    `₹${CurrencyConverter.toCurrency(
                      Number(item?.returnIgstamount || 0),
                      "INR",
                    )}`
                  )}
                </td>
              </tr>
            ))} */}
            {!isLoading && isData?.reportSummary && (
              <tr className="font-bold border-t bg-gray-100">
                <td>Total</td>
                {/* <td>
                  ₹
                  {CurrencyConverter.toCurrency(
                    isData.reportSummary.totalTaxAmount || 0,
                    "INR",
                  )}
                </td> */}
                <td className="text-end">
                  {formatCurrency(
                    CurrencyConverter.toCurrency(
                      isData.reportSummary?.returnCgstamount || 0,
                      "INR",
                    ),
                    "INR",
                    false,
                    true,
                  )}
                </td>
                <td className="text-end">
                  {formatCurrency(
                    CurrencyConverter.toCurrency(
                      isData.reportSummary?.returnSgstamount || 0,
                      "INR",
                    ),
                    "INR",
                    false,
                    true,
                  )}
                </td>
                <td className="text-end">
                  {formatCurrency(
                    CurrencyConverter.toCurrency(
                      isData.reportSummary?.returnIgstamount || 0,
                      "INR",
                    ),
                    "INR",
                    false,
                    true,
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {!templateId && isViewTempModalOpen && (
        <InvoiceTempPreview
          isData={viewData}
          onClose={() => setViewTempModalOpen(false)}
          onAdd={handleSetTemplate}
        />
      )}
      {templateId && isViewModalOpen && (
        <TemplateModalLayout
          isOpen={isViewModalOpen}
          isData={viewData}
          onClose={handleSaleClose}
          selectedOption={selectedReturnOption}
          setSelectedOption={setSelectedReturnOption}
          setSaleData={setViewData}
          isActive={isActive}
        />  
      )}
      {reportModelOpen && (
        <ReportView onClose={closeSaleReportView} viewData={viewData} />
      )}
    </>
  );
};

export default ViewReportSalesReport;
